import type { ReactNode } from 'react'
import type { Project } from '@/types/api'
import {
  IconApps,
  IconBolt,
  IconCloud,
  IconCode,
  IconCopy,
  IconDesktop,
  IconImage,
  IconMonitorStroked,
  IconTicketCode,
} from '@douyinfe/semi-icons'
import { Nav, Typography } from '@douyinfe/semi-ui'

interface ProjectMenuProps {
  projects: Project[]
  collapsed?: boolean
}

const projectIconMap: Record<string, ReactNode> = {
  imageoptimizer: <IconImage size="large" />,
  floweb: <IconCloud size="large" />,
  copystyle: <IconCopy size="large" />,
  pichound: <IconDesktop size="large" />,
  codeexpander: <IconCode size="large" />,
  subwright: <IconTicketCode size="large" />,
  zapicon: <IconBolt size="large" />,
}

function getProjectIcon(code: string) {
  return projectIconMap[code] || <IconMonitorStroked size="large" />
}

export function ProjectMenu({ projects, collapsed }: ProjectMenuProps) {
  if (projects.length === 0) {
    return null
  }

  return (
    <>
      {!collapsed && (
        <div
          style={{
            padding: '16px 20px 8px',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <IconApps
            size="small"
            style={{ color: 'var(--semi-color-text-2)' }}
          />
          <Typography.Text type="tertiary" size="small" strong>
            项目管理
          </Typography.Text>
        </div>
      )}
      {projects.map(project => (
        <Nav.Item
          key={project.code}
          itemKey={`/projects/${project.code}`}
          text={project.name}
          icon={getProjectIcon(project.code)}
          link={`/projects/${project.code}`}
        />
      ))}
    </>
  )
}
